<router-outlet #o="outlet" *ngIf="translateLoaded()"></router-outlet>
<app-preview-file-fullscreen></app-preview-file-fullscreen>
